import axiosPost from '../axiosPost';
import { MerchantUsuarioType, UserCredentialsType } from '../../../types/types';
import { AxiosPostBody } from '../../../types/AxiosPost';

export const MerchantCheck = async (arg: UserCredentialsType, cuit: string) => {
    const body: AxiosPostBody = {
        "service": "MerchantCheck",
        "params": {
            merchantCUIT: cuit
        }
    }

    try {
        const result = await axiosPost<MerchantUsuarioType>('Y', body, arg);
        return result
        
    } catch (err) {
        console.log(err)
    }
}